var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('the-header'),_c('app-list',{on:{"showPlayer":_vm.showPlayer}}),(_vm.isPlayerShowed)?_c('youtube-player',{attrs:{"videoId":_vm.videoId},on:{"closePlayer":_vm.closePlayer}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }